import clsx from 'clsx'
import { WebhooksContent } from '../WebhooksContent/WebhooksContent'
import css from './Page.module.css'

export function WebhooksPage() {
	return (
		<main className={clsx(css.root, 'main app-scroll', css.content)}>
			<WebhooksContent />
		</main>
	)
}